"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Captcha = void 0;
var react_1 = __importStar(require("react"));
var Label_1 = require("./Label");
var mobx_react_1 = require("mobx-react");
var react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
var styles = __importStar(require("./Captcha.module.css"));
var Captcha = (function (_super) {
    __extends(Captcha, _super);
    function Captcha() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Captcha.prototype.componentDidMount = function () {
    };
    Captcha.prototype.render = function () {
        var _a = this.props, errors = _a.errors, onChange = _a.onChange, recaptchaRef = _a.recaptchaRef;
        return (react_1.default.createElement("div", { className: styles.checkBoxWrapper },
            react_1.default.createElement(Label_1.Label, { text: "", error: errors["captcha_value"], required: true },
                react_1.default.createElement(react_google_recaptcha_1.default, { sitekey: "".concat(process.env.APP_CAPTCHA_KEY), size: "normal", render: "explicit", ref: recaptchaRef, onChange: function (value) {
                        onChange("captcha_value", value);
                    }, onExpired: function () {
                        onChange("captcha_value", null);
                        recaptchaRef.current.reset();
                    } }))));
    };
    Captcha = __decorate([
        mobx_react_1.observer
    ], Captcha);
    return Captcha;
}(react_1.Component));
exports.Captcha = Captcha;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FwdGNoYS5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2NvbXBvbmVudHMvQ2FwdGNoYS9DYXB0Y2hhLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUFxRDtBQUNyRCxpQ0FBNkI7QUFDN0IseUNBQW1DO0FBQ25DLGtGQUE4QztBQUM5QywyREFBOEM7QUFZOUM7SUFBNkIsMkJBQWdCO0lBQTdDOztJQWdDQSxDQUFDO0lBL0JHLG1DQUFpQixHQUFqQjtJQUlBLENBQUM7SUFFTSx3QkFBTSxHQUFiO1FBQ1UsSUFBQSxLQUFtQyxJQUFJLENBQUMsS0FBSyxFQUE1QyxNQUFNLFlBQUEsRUFBRSxRQUFRLGNBQUEsRUFBRSxZQUFZLGtCQUFjLENBQUE7UUFHbkQsT0FBTyxDQUNILHVDQUFLLFNBQVMsRUFBRSxNQUFNLENBQUMsZUFBZTtZQUNsQyw4QkFBQyxhQUFLLElBQUMsSUFBSSxFQUFDLEVBQUUsRUFBQyxLQUFLLEVBQUUsTUFBTSxDQUFDLGVBQWUsQ0FBQyxFQUFFLFFBQVE7Z0JBQ25ELDhCQUFDLGdDQUFTLElBQ04sT0FBTyxFQUFFLFVBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQyxlQUFlLENBQUUsRUFDekMsSUFBSSxFQUFDLFFBQVEsRUFDYixNQUFNLEVBQUMsVUFBVSxFQUNqQixHQUFHLEVBQUUsWUFBWSxFQUNqQixRQUFRLEVBQUUsVUFBQyxLQUFLO3dCQUNaLFFBQVEsQ0FBQyxlQUFlLEVBQUUsS0FBSyxDQUFDLENBQUE7b0JBQ3BDLENBQUMsRUFDRCxTQUFTLEVBQUU7d0JBQ1AsUUFBUSxDQUFDLGVBQWUsRUFBRSxJQUFJLENBQUMsQ0FBQTt3QkFDL0IsWUFBWSxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsQ0FBQTtvQkFDaEMsQ0FBQyxHQUVILENBQ0UsQ0FDTixDQUNULENBQUE7SUFDTCxDQUFDO0lBL0JRLE9BQU87UUFEbkIscUJBQVE7T0FDSSxPQUFPLENBZ0NuQjtJQUFELGNBQUM7Q0FBQSxBQWhDRCxDQUE2QixpQkFBUyxHQWdDckM7QUFoQ1ksMEJBQU8ifQ==